import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import type { JSX } from 'react';

export interface ToggleButtonProps {
  isOpen: boolean;
  buttonLabel: string;
  className?: string;
  onClick: () => void;
}

export const ToggleButton = ({ isOpen, buttonLabel, onClick, className }: ToggleButtonProps): JSX.Element => (
  <CL.Button color="link" size="l" onClick={onClick} className={className}>
    <span className={dsClass.MARGIN_RIGHT_1}>{buttonLabel}</span>
    <CL.Icon key={isOpen.toString()} icon={isOpen ? 'arrow-up' : 'arrow-down'} />
  </CL.Button>
);
